export function el(tag, className, text) {
    const node = document.createElement(tag);
    if (className)
        node.className = className;
    if (text !== undefined)
        node.textContent = text;
    return node;
}
export function setStatus(node, message, type) {
    node.className =
        type === "error" ? "flash flash-error" : type === "success" ? "flash flash-success" : "muted";
    node.textContent = message;
}
export function createStatusController(status) {
    let statusClearTimer = null;
    const clear = () => {
        if (statusClearTimer !== null) {
            clearTimeout(statusClearTimer);
            statusClearTimer = null;
        }
    };
    const showStatus = (message, type, opts) => {
        clear();
        setStatus(status, message, type);
        status.hidden = !message;
        if (type === "success" && message) {
            const hideAfter = opts?.autoHideMs ?? 5000;
            statusClearTimer = setTimeout(() => {
                status.hidden = true;
                statusClearTimer = null;
            }, hideAfter);
        }
    };
    return { showStatus, clear };
}
